import Stickyfill from "stickyfilljs"

const attachAll = () => {
  // 100vw doesn't account for vertical scrollbars. We need to set a custom
  // variable the CSS can read to do calc(100vw - var(--scrollbar-width))
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    (window.innerWidth - document.documentElement.clientWidth) + "px"
  )

  const savebars = document.querySelectorAll('.savebar-container')
  Stickyfill.add(savebars)

  const intersectionObserver = new IntersectionObserver(
    ([e]) => {
      e.target.toggleAttribute('stuck', e.intersectionRatio < 1)
      document.querySelector('body').classList.toggle('savebar-stuck', e.intersectionRatio < 1)
    },
    {threshold: [1]}
  )

  savebars.forEach(savebar => intersectionObserver.observe(savebar))

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.target.querySelectorAll('.savebar-container').forEach(element => {
        intersectionObserver.observe(element)
      })
    })
  })

  mutationObserver.observe(document.body, { childList: true, subtree: true })
}

export default { attachAll }
